import React, {ChangeEvent, FC, useContext, useEffect, useMemo, useState} from "react";
import {DisplayDesignItem} from "../../api/response/DisplayDesign";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField
} from "@mui/material";
import MonacoEditor from "react-monaco-editor";
import {DeleteDisplayDesign, PostDisplayDesign} from "../../api/DisplayDesignApi";
import {AppContext} from "../../App";
import {useHistory} from "react-router-dom";
import {SimpleDialog} from "../dialog/SimpleDialog";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';

type Props = {
  originItem: DisplayDesignItem,
  updateList: () => void
}

export const DisplayEdit: FC<Props> = ({originItem, updateList}) => {
  const [item, setItem] = useState<DisplayDesignItem>({...originItem})
  const [tab, setTab] = useState<number>(0)
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false)
  const { dispatch} = useContext(AppContext);
  const history = useHistory()
  const isNewDesign = useMemo(() => {
    return item.id == null
  }, [item])

  const handleSetTab = (_: unknown, newValue: number) => {
    setTab(newValue)
  }

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setItem({...item, name: e.target.value})
  }

  const handleCommentChange = (e: ChangeEvent<HTMLInputElement>) => {
    setItem({...item, comment: e.target.value})
  }

  const handleIsPublicChange = () => {
    setItem({...item, is_public: Math.abs(item.is_public - 1)})
  }

  const handleIsPcChange = () => {
    setItem({...item, is_pc: Math.abs(item.is_public - 1)})
  }

  const handleSave = async () => {
    try {
      const displayItem = await PostDisplayDesign(item)
      updateList()
      //新規作成の場合は、画面ごと移動したほうがよい
      if (isNewDesign) {
        history.push(`./display_design?id=${displayItem.id}`)
      } else {
        setItem(displayItem)
      }

      dispatch({
        type: "setNotification",
        payload: "保存しました。"
      })

    } catch (e: any) {
      dispatch({
        type: "setError",
        payload: {error: true, message: e.message}
      });
    }
  }

  const handleDelete = async () => {
    if (item.id == null) return
    try {
      await DeleteDisplayDesign(item.id)
      updateList()
      history.push(`./display_design`)
      dispatch({
        type: "setNotification",
        payload: "削除しました。"
      })
    } catch (e: any) {
      dispatch({
        type: "setError",
        payload: {error: true, message: e.message}
      })
    }
  }

  const editText = useMemo(() => {
    switch (tab) {
      case 0:
        return item.css
      case 1:
        return item.header_html
      case 2:
        return item.footer_html
      default:
        throw new Error()
    }
  }, [tab, item])

  const handleUpdateText = (newValue: string) => {
    setItem({
      ...item,
      css: tab === 0 ? newValue : item.css,
      header_html: tab === 1 ? newValue : item.header_html,
      footer_html: tab === 2 ? newValue : item.footer_html
    })
  }

  useEffect(() => {
    setItem({...originItem})
  }, [originItem])
  return <Paper>
    <SimpleDialog
      content="この画面デザインを削除してもよろしいですか？"
      open={confirmDialogOpen}
      confirmText={"削除する"}
      onConfirm={handleDelete}
      onClose={() => {
        setConfirmDialogOpen(false)
      }}/>
    <Box>
      <Stack p={1} sx={{borderBottom: 1, borderColor: 'grey.300'}} direction="row" spacing={2}>
        <Button startIcon={<SaveIcon/>} onClick={handleSave}>保存</Button>
        {!isNewDesign && <Button startIcon={<DeleteIcon/>} onClick={() => {
          setConfirmDialogOpen(true)
        }} color={"error"}>削除</Button>}

      </Stack>

      <Box p={2}>
        <Stack direction="row" spacing={1} p={1}>
          <TextField value={item.name} label={"デザインの名前"} onChange={handleNameChange} size="small"/>
          <TextField value={item.comment} label={"デザインの概要"} onChange={handleCommentChange} size="small"/>
        </Stack>
        <Stack direction="row" spacing={1} p={1}>
          <FormControl>
            <InputLabel id="is-public-label">公開設定</InputLabel>
            <Select value={item.is_public} onChange={handleIsPublicChange} size="small"
                    labelId="is-public-label" label={"公開設定"}>
              <MenuItem value={0}>自分だけ使用可能</MenuItem>
              <MenuItem value={1}>他のユーザーにも使用可能</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel id="is-pc-label">デバイス設定</InputLabel>
            <Select value={item.is_pc} onChange={handleIsPcChange} size="small" labelId="is-pc-label" label={"デバイス設定"}>
              <MenuItem value={1}>PC用</MenuItem>
              <MenuItem value={0}>スマートフォン用</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Box>
      <Tabs onChange={handleSetTab} value={tab}>
        <Tab label="css"/>
        <Tab label="header html"/>
        <Tab label="footer html"/>
      </Tabs>

      <div>
        <MonacoEditor
          value={editText}
          width="100%"
          height={600}
          onChange={handleUpdateText}
        />
      </div>
    </Box>
  </Paper>
}